<div id="wrapper">
    <app-navbar></app-navbar>
    <app-sidebar [isCondensed]="false"></app-sidebar>
    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/manage-queries">Queries</a>
                        </span>
                        <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a>Query Detail</a>
                        </span>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-lg-12 col-xl-12">
                            <div class="modern-card">
                                <div class="card-header-modern">
                                    <h5 class="mb-0" style="font-size: 1.15rem;"><i class="ri-file-list-3-line me-2"></i>Query Details</h5>
                                </div>
                                <div class="card-body-modern">
                                    <div *ngIf="loading" class="text-center py-5">
                                        <app-loader></app-loader>
                                    </div>
                                    <div *ngIf="errorMsg && !loading" class="alert alert-danger text-center">{{ errorMsg }}</div>
                                    <ng-container *ngIf="!loading && !errorMsg">
                                        <form class="modern-form-detail">
                                            <div class="row g-3">
                                                
                                                <!-- Query Reason -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Query Reason:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.title || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Query ID -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Query ID:</label>
                                                        <div class="readonly-input">{{ queryDetail.requestNumber || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Status:</label>
                                                        <div class="readonly-input">
                                                            <ng-container *ngIf="queryDetail.ticket?.currentState; else noStatus">
                                                                {{ queryDetail.ticket.currentState.stateName || '' }}
                                                            </ng-container>
                                                            <ng-template #noStatus>No Status</ng-template>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-md-4" *ngIf="queryDetail.ticket?.currentState?.stateName === 'Clarification Required'">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">JSW Remark:</label>
                                                        <div class="readonly-input">
                                                            <ng-container *ngIf="queryDetail.ticket?.currentState; else noStatus">
                                                                {{ queryDetail.ticket.enclosures[0]?.comment || 'No Remarks' }}
                                                            </ng-container>
                                                            <ng-template #noStatus>No Remarks</ng-template>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Is the query related to an existing query? -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Is the query related to an existing query?</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute123?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Reference Query ID -->
                                                <div class="col-md-8">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Reference Query ID</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute124?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>
                                                
                                                <!-- Barcode No -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Barcode No:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute122?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Invoice No -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Invoice No:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute81?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- PO No -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">PO No:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute80?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Period of Ledger -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Period of Ledger:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute117?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Vendor Code -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Vendor Code:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute38?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Vendor Name -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Vendor Name:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute114?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Vendor Contact -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Vendor Contact:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute55?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Business -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Business:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute54?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Location -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Location:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute103?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                 <!-- PAN -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">PAN:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute10?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- PERIOD -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Period:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute115?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Selected Concern Type -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Concern Type:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute118?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- UTR/CMS Number -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">UTR/CMS Number:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute120?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Payment Reference Number -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Payment Reference Number:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute121?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Received Amount -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Received Amount:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute119?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>

                                                <!-- Request Date -->
                                                <div class="col-md-4">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Payment Date:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.additionalParams?.attribute18?.data || 'No Data' }}</div>
                                                    </div>
                                                </div>
            
                                                <!-- Query Description -->
                                                <div class="col-md-12">
                                                    <div class="form-group-detail">
                                                        <label class="fw-semibold">Query Description:</label>
                                                        <div class="readonly-input">{{ queryDetail.ticket?.probDescription || 'No Data' }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                        </form>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
